export const environment = {
    production: true,
    apiUrl: 'https://qa.api.gsk.com/Pharmatech/Vaxikart/',
    apiKey:'OGYxMzA1MjUtMjFhNi00NmM0LTg2OTItYjZlZDJlYTM2N2E3i-oGhCUokIYTYipgAZIM-LMtLbg8kdwaCxtkJ1VP2Xge'
  };